/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ let $6a20a7989e6c817a$var$_tableNestedRows = false;
let $6a20a7989e6c817a$var$_shadowDOM = false;
function $6a20a7989e6c817a$export$d9d8a0f82de49530() {
    $6a20a7989e6c817a$var$_tableNestedRows = true;
}
function $6a20a7989e6c817a$export$1b00cb14a96194e6() {
    return $6a20a7989e6c817a$var$_tableNestedRows;
}
function $6a20a7989e6c817a$export$12b151d9882e9985() {
    $6a20a7989e6c817a$var$_shadowDOM = true;
}
function $6a20a7989e6c817a$export$98658e8c59125e6a() {
    return $6a20a7989e6c817a$var$_shadowDOM;
}


export {$6a20a7989e6c817a$export$d9d8a0f82de49530 as enableTableNestedRows, $6a20a7989e6c817a$export$1b00cb14a96194e6 as tableNestedRows, $6a20a7989e6c817a$export$12b151d9882e9985 as enableShadowDOM, $6a20a7989e6c817a$export$98658e8c59125e6a as shadowDOM};
//# sourceMappingURL=flags.mjs.map
